@if (product === "FP1") {
    <h3 i18n>Vozidlo</h3>
} @else {
    <h2 i18n>Vozidlo</h2>
}
@if (vehicleForm && options) {
    <ul class="u-input-menu">
        @for (dt of _htmlData; track $index) {
            @if (visibilities[dt.name]) {
                <li class="menu-item">
                    <app-tooltip
                        [tooltip]="
                            dt.name && dt.name !== 'clientsVehiclePrice' ? tooltips[dt.name] : null
                        ">
                        <label>{{ dt.title }}</label>
                    </app-tooltip>

                    <div class="cont">
                        @if (dt.type === "select") {
                            <mat-form-field
                                class="full_width"
                                appearance="fill"
                                subscriptSizing="dynamic"
                                [class.form-group--error]="_htmlFunIsFCInvalid(dt.name)">
                                <mat-select
                                    disableOptionCentering
                                    [formControl]="
                                        dt.name === 'spz' ? spz : vehicleForm.controls[dt.name]
                                    "
                                    (blur)="onBlur(dt.name)"
                                    #item
                                    required>
                                    @for (val of options[dt.name]; track val.value) {
                                        <!-- dt.name !== "vehicleType" ||
                                        product !== "FP1" || -->
                                        @if (
                                            (product !== "FP1" ||
                                                !["EV", "EK"].includes(val.value)) &&
                                            (dt.name !== "model" ||
                                                val.valid ||
                                                    val.value ===
                                                        vehicleForm.controls[dt.name].value)
                                        ) {
                                            <mat-option [value]="val.value">
                                                {{ val.text }}
                                            </mat-option>
                                        }
                                    }
                                </mat-select>
                                @if (_htmlFunIsFCInvalid(dt.name)) {
                                    <mat-error>
                                        <ng-container
                                            *ngTemplateOutlet="errors; context: { aa: dt }" />
                                    </mat-error>
                                }
                            </mat-form-field>
                        } @else if (dt.type === "input") {
                            <mat-form-field
                                subscriptSizing="dynamic"
                                [class.form-group--error]="_htmlFunIsFCInvalid(dt.name)">
                                <input
                                    matInput
                                    #item
                                    required
                                    [formControl]="vehicleForm.controls[dt.name]"
                                    [name]="dt.name"
                                    (blur)="onBlur(dt.name)" />
                                @if (_htmlFunIsFCInvalid(dt.name)) {
                                    <mat-error>
                                        <ng-container
                                            *ngTemplateOutlet="errors; context: { aa: dt }" />
                                    </mat-error>
                                }
                            </mat-form-field>
                        } @else if (dt.type === "number" && isElectro !== undefined) {
                            <mat-form-field
                                subscriptSizing="dynamic"
                                [class.form-group--error]="_htmlFunIsFCInvalid(dt.name)"
                                [class.reduced]="dt.name === 'clientsVehiclePrice'">
                                <app-num-input
                                    #item
                                    required
                                    [unit]="dt.extras.unit"
                                    [unitSub]="dt.extras.unitSub"
                                    [formControl]="vehicleForm.controls[dt.name]"
                                    (blurEvent)="onBlur(dt.name)"
                                    [numOfDecimals]="
                                        dt.name === 'enginePower' ? (isElectro ? 2 : 0) : 0
                                    " />
                                @if (_htmlFunIsFCInvalid(dt.name)) {
                                    <mat-error>
                                        <ng-container
                                            *ngTemplateOutlet="errors; context: { aa: dt }" />
                                    </mat-error>
                                }
                            </mat-form-field>
                        } @else if (dt.type === "date") {
                            <mat-form-field
                                [class.form-group--error]="_htmlFunIsFCInvalid(dt.name)"
                                subscriptSizing="dynamic">
                                <input
                                    matInput
                                    [matDatepicker]="item"
                                    autocomplete="off"
                                    [min]="minDate"
                                    [max]="maxDate"
                                    [formControl]="vehicleForm.controls[dt.name]"
                                    [name]="dt.name"
                                    required
                                    (blur)="onBlurOnDate(dt.name)"
                                    (dateChange)="onBlurOnDate(dt.name)"
                                    (click)="item.open()" />
                                <mat-datepicker #item />
                                <mat-datepicker-toggle matSuffix [for]="item">
                                    <img
                                        matDatepickerToggleIcon
                                        class="u-dt-icon"
                                        src="assets/img/input-list.png"
                                        alt="" />
                                </mat-datepicker-toggle>
                                @if (_htmlFunIsFCInvalid(dt.name)) {
                                    <mat-error>
                                        <ng-container
                                            *ngTemplateOutlet="errors; context: { aa: dt }" />
                                    </mat-error>
                                }
                            </mat-form-field>
                        } @else if (dt.type === "radio") {
                            <div
                                class="form-group"
                                [class.form-group--error]="_htmlFunIsFCInvalid(dt.name)">
                                <mat-radio-group
                                    class="check form-control-nc"
                                    #item
                                    [formControl]="vehicleForm.controls[dt.name]"
                                    (blur)="onBlur(dt.name)"
                                    required>
                                    @for (radio of dt.extras; track radio.value) {
                                        <mat-radio-button [value]="radio.value">
                                            {{ radio.title }}
                                        </mat-radio-button>
                                    }
                                </mat-radio-group>
                                @if (_htmlFunIsFCInvalid(dt.name)) {
                                    <div class="warning">
                                        <ng-container
                                            *ngTemplateOutlet="errors; context: { aa: dt }" />
                                    </div>
                                }
                            </div>
                        } @else if (dt.name === "clientsVehiclePrice") {
                            <div class="u-button-shadowless suffix">
                                <u
                                    i18n
                                    (click)="onShowTooltip(dt.name)"
                                    tabindex="0"
                                    (keydown.enter)="onShowTooltip(dt.name)">
                                    Jak určit?
                                </u>
                            </div>
                        }
                    </div>
                </li>
            }
        }

        @if ((spz.value || !hideAllAfterSPZ) && product !== "FP1") {
            <li class="menu-item">
                <app-tooltip [tooltip]="tooltips.sameAsUser">
                    <label (click)="radio.focus()" tabindex="-1" (keydown.enter)="radio.focus()">
                        {{ sameAsUserText }}
                    </label>
                </app-tooltip>
                <div class="form-group">
                    <mat-radio-group
                        class="check form-control-nc"
                        [formControl]="sameAsUserFc"
                        required
                        #radio>
                        <mat-radio-button [value]="true" i18n>shodný s klientem</mat-radio-button>
                        <mat-radio-button [value]="false" i18n>jiný</mat-radio-button>
                    </mat-radio-group>
                </div>
            </li>
        }
        @if (product === "FP1") {
            <!-- <li class="menu-item">
                <span i18n>PSČ-obec {{zipCodeCity?.value?.zipCode}}</span>
                <mat-form-field
                    subscriptSizing="dynamic"
                    [ngClass]="{
                        'form-group--error':
                            !o.disabled && zipCodeCity.touched && !zipCodeCity.valid,
                    }">
                    <input
                        type="text"
                        matInput
                        [matAutocomplete]="autoZipCode"
                        [formControl]="zipCodeCity"
                        (blur)="_htmlFunZipBlur()" />
                    <img matSuffix src="assets/img/input-search.png" alt="" />
                    <mat-autocomplete
                        #autoZipCode="matAutocomplete"
                        class="no-wrap"
                        classList="no-wrap"
                        [displayWith]="_htmlFunDisplayFn"
                        (optionSelected)="_htmlFunSetZipcodeCity($event.option.value)">
                        @if (isLoadingZip) {
                            <mat-option>
                                <span i18n>Načítání...</span>
                            </mat-option>
                        } @else {
                            @for (item of zips; track item.municipalityCode) {
                                <mat-option [value]="item">
                                    <span>{{ item.zipCode }}-{{ item.city }}</span>
                                </mat-option>
                            }
                        }
                    </mat-autocomplete>
                    @if (zipCodeCity.touched && !zipCodeCity.valid) {
                        <mat-error>
                            @if (zipCodeCity.errors?.message) {
                                {{ zipCodeCity.errors.message }}
                            } @else if (zipCodeCity.errors?.required) {
                                <ng-container i18n>
                                    Údaj PSČ - obec musí být vyplněn.
                                </ng-container>
                            }
                        </mat-error>
                    }
                </mat-form-field>
            </li> -->
            <li class="menu-item">
                <div>
                    <app-tooltip [tooltip]="tooltips.vIN">
                        <label i18n>VIN</label>
                    </app-tooltip>
                </div>
                <mat-form-field
                    subscriptSizing="dynamic"
                    [class.form-group--error]="_htmlFunIsFCInvalid('vIN')">
                    <input
                        matInput
                        #item
                        [formControl]="vehicleForm.controls.vIN"
                        required
                        (blur)="onBlur('vIN')"
                        (blur)="trimServ.trim(vehicleForm.controls.vIN)" />
                    @if (_htmlFunIsFCInvalid("vIN")) {
                        <mat-error>
                            {{ vehicleForm.controls.vIN.errors.message }}
                        </mat-error>
                    }
                </mat-form-field>
            </li>
            <li class="menu-item">
                <div>
                    <app-tooltip [tooltip]="tooltips.technicalCertificateNumber">
                        <label i18n>TP / nové osvědčení</label>
                    </app-tooltip>
                    <span i18n>(nepovinné pro kalkulaci)</span>
                </div>
                <mat-form-field
                    subscriptSizing="dynamic"
                    [class.form-group--error]="_htmlFunIsFCInvalid('technicalCertificateNumber')">
                    <input
                        matInput
                        [formControl]="vehicleForm.controls.technicalCertificateNumber"
                        (blur)="onBlur('technicalCertificateNumber')" />
                    @if (_htmlFunIsFCInvalid("technicalCertificateNumber")) {
                        <mat-error>
                            {{ vehicleForm.controls.technicalCertificateNumber.errors.message }}
                        </mat-error>
                    }
                </mat-form-field>
            </li>
            <li class="menu-item">
                <div class="empty"></div>
                <mat-checkbox
                    [formControl]="vehicleForm.controls.noTechnicalCertificate"
                    class="whited"
                    i18n>
                    TP zatím nepřidělen
                </mat-checkbox>
            </li>
        }
    </ul>
}

@if (buVisible) {
    <div class="u-btn u-bu-bigger">
        <button (click)="onFinishHim()" i18n>Spočítat</button>
    </div>
}

<ng-template #errors let-person="aa">
    @if (
        !vehicleForm.get(person.name).errors?.message &&
        !vehicleForm.get(person.name).errors?.matDatepickerParse &&
        person.name !== "phone" &&
        vehicleForm.get(person.name).errors?.required
    ) {
        <ng-container i18n> Údaj {{ person.title }} musí být vyplněn. </ng-container>
    }
    @if (vehicleForm.get(person.name).errors?.message) {
        <ng-container>
            {{ vehicleForm.get(person.name).errors.message }}
        </ng-container>
    }
    @if (vehicleForm.get(person.name).errors?.matDatepickerParse) {
        <ng-container i18n> Chybně vyplněné datum. Prosíme o opravu. </ng-container>
    }
</ng-template>
